export default __webpack_public_path__ + "static/media/DJ.6ee172c1.svg";